/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: cases_analytics.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type { GetCasesAnalyticsRequest, GetCasesAnalyticsResponse } from '../types/cases_analytics';

export const createCasesAnalyticsService = (transport: Transport) => ({
  async getCasesAnalytics(
    request: GetCasesAnalyticsRequest,
    options: RequestOptions = {},
  ): Promise<GetCasesAnalyticsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.CasesAnalyticsService.GetCasesAnalytics, {
      organization_id,
    });
    return transport.get<GetCasesAnalyticsResponse>(url, { params, ...options });
  },
});

export type CasesAnalyticsService = ReturnType<typeof createCasesAnalyticsService>;
